import type {
  ExternalDropdownOptions,
  ExternalDropdownOptionsFlat,
  ExternalDropdownOptionsGrouped,
  InternalDropdownOption,
  InternalDropdownOptions,
} from '~/chords/DropdownSingleSelect/types';

export interface GetExternalToInternalOptionsResult {
  internalOptions: InternalDropdownOptions;
  selectedOption?: InternalDropdownOption;
}

/**
 * Transforms external dropdown options into internal dropdown options.
 * Supports both flat and grouped option arrays.
 * @param externalOptions - The external dropdown options to transform (flat or grouped).
 * @param param1.selectedValue - The currently selected value.
 * @returns The transformed internal dropdown options and the selected option if found.
 */
export function updateExternalToInternal(
  externalOptions: ExternalDropdownOptions,
  { selectedValue }: { selectedValue?: string },
): GetExternalToInternalOptionsResult {
  let selectedOption: InternalDropdownOption | undefined;
  let optionIndex = 0;

  const externalOptionsGrouped = Array.isArray(externalOptions[0])
    ? (externalOptions as ExternalDropdownOptionsGrouped)
    : [externalOptions as ExternalDropdownOptionsFlat];

  const internalOptions: InternalDropdownOptions = externalOptionsGrouped.map(
    (group) =>
      group.map((option) => {
        const isSelected = option.value === selectedValue;

        const internalOption: InternalDropdownOption = {
          ...option,
          isSelected,
          isVisible: option.isVisible ?? true,
          optionIndex: optionIndex++,
        };

        if (isSelected) {
          selectedOption = internalOption;
        }

        return internalOption;
      }),
  );

  return { internalOptions, selectedOption };
}
